export enum Team {
  AI_TEAM = 'ENG_AI',
  ANALYTICS_TEAM = 'ENG_ANALYTICS',
  ANALYTICS_PLATFORM_TEAM = 'ENG_ANALYTICS_PLATFORM',
  AUDIENCE_TEAM = 'ENG_AUDIENCE',
  CAMPAIGN_TEAM = 'ENG_CAMPAIGN',
  CONTENT_TEAM = 'ENG_CONTENT',
  CONTENT_AND_JOURNEYS_TEAM = 'ENG_CONTENT_AND_JOURNEYS',
  ECOSYSTEM_TEAM = 'ENG_ECOSYSTEM',
  EXPERIMENT_TEAM = 'ENG_EXPERIMENT',
  JOURNEY_TEAM = 'ENG_JOURNEY',
  MOBILE_TEAM = 'ENG_MOBILE',
  NOVA_TEAM = 'ENG_NOVA',
  PLATFORM_TEAM = 'ENG_PLATFORM',
  UNSPECIFIED = 'ENG_UNSPECIFIED',
}

export enum Product {
  /** AI Team */
  PRG = 'PrG',
  COPY_ASSIST = 'COPY_ASSIST',
  BRAND_AFFINITY_INSIGHTS = 'BRAND_AFFINITY_INSIGHTS',
  FRO_INSIGHTS = 'FRO_INSIGHTS',

  /** ANALYTICS TEAM */
  CAMPAIGN_PERFORMANCE = 'CAMPAIGN_PERFORMANCE',
  DASHBOARD = 'DASHBOARD',
  MESSAGING_INSIGHTS = 'MESSAGING_INSIGHTS',
  REPORTS = 'REPORTS',
  SAVED_VIEWS = 'SAVED_VIEWS',

  /** ANALYTICS PLATFORM TEAM */
  ETL = 'EXTRACT_TRANSFORM_LOAD',

  /** AUDIENCE TEAM */
  AUDIENCE_INSIGHTS = 'AUDIENCE_INSIGHTS',
  CATALOG = 'CATALOG',
  CONTACT_LOOKUP = 'CONTACT_LOOKUP',
  FACEBOOK = 'FACEBOOK',
  LISTS = 'LISTS',
  SEGMENTATION = 'SEGMENTATION',
  USER_PROFILE = 'USER_PROFILE',
  DYNAMIC_CONTENT_BUILDER = 'DYNAMIC_CONTENT_BUILDER',

  /** CAMPAIGN TEAM */
  CAMPAIGN_EDITOR = 'CAMPAIGN_EDITOR',
  CAMPAIGN_INDEX = 'CAMPAIGN_INDEX',
  TEMPLATE_SELECTOR = 'TEMPLATE_SELECTOR',
  CAMPAIGN_PROJECT_ALERTS = 'CAMPAIGN_PROJECT_ALERTS',
  CAMPAIGNS_SENT_MESSAGES_LOGS = 'CAMPAIGNS_SENT_MESSAGES_LOGS',
  TEMPLATE_EDITOR = 'TEMPLATE_EDITOR',
  TEMPLATE_INDEX = 'TEMPLATE_INDEX',
  DRAG_AND_DROP_EDITOR = 'DRAG_AND_DROP_EDITOR',
  CAMPAIGN_CALENDAR = 'CAMPAIGN_CALENDAR',

  /** CONTENT TEAM */
  CREATIVE_LIBRARY = 'CREATIVE_LIBRARY',
  DATA_FEEDS = 'DATA_FEEDS',
  MOVABLE_INK = 'MOVABLE_INK',
  NAVIGATION = 'NAVIGATION',
  SNIPPETS = 'SNIPPETS', // modules/snippets

  /** CONTENT AND JOURNEYS TEAM */
  GRAPHIQL = 'GRAPHIQL',

  /** ECOSYSTEM TEAM */
  JOB_MANAGER = 'JOB_MANAGER',

  /** EXPERIMENT TEAM */
  EXPERIMENT_EDITOR = 'EXPERIMENT_EDITOR',
  EXPERIMENT_INDEX = 'EXPERIMENT_INDEX',
  EXPERIMENT_MONITOR = 'EXPERIMENT_MONITOR',
  ITERABLE_GOALS = 'ITERABLE_GOALS',
  CHOOSE_CAMPAIGN = 'CHOOSE_CAMPAIGN',

  /** JOURNEYS TEAM */
  JOURNEY_INDEX = 'JOURNEY_INDEX',
  JOURNEY_STUDIO = 'JOURNEY_STUDIO',

  /** MOBILE TEAM */
  MOBILE_APPS = 'MOBILE_APPS',
  WEB_PUSH = 'WEB_PUSH',
  EMBEDDED_PLACEMENTS = 'EMBEDDED_PLACEMENTS',
  ANONYMOUS_USER_TRACKING = 'ANONYMOUS_USER_TRACKING',

  /** NOVA TEAM */
  HOMEPAGE = 'HOMEPAGE',
  GOALS_INDEX = 'GOALS_INDEX',

  /** PLATFORM TEAM */
  ADMIN = 'ADMIN',
  PAYMENTS = 'PAYMENTS',
  PREFERENCES = 'PREFERENCES',
  QUICK_ACTIONS = 'QUICK_ACTIONS',
  ROLES = 'ROLES',
  SETTINGS = 'SETTINGS',
  TRIGGERS = 'TRIGGERS',
  WEB_HOOK = 'WEB_HOOK',
  // add INTEGRATIONS?

  /** UNSPECIFIED TEAM */
  UNSPECIFIED = 'UNSPECIFIED_PRODUCT',
}
